import { useState } from "react";
import axios from "axios";
import CrearOpciones from "./CreaOpciones";
import {
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Container,
  Typography,
  Alert,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";


const CrearPregunta = ({ idFormPrincipal }) => {
  let { id } = useParams();
  const navigate = useNavigate(); // Hook para redirigir
  const [nombre, setNombre] = useState("");
  const [tipo, setTipo] = useState("Texto");
  const [preguntaId, setPreguntaId] = useState(null); // Guarda el ID de la pregunta creada
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const nuevaPregunta = {
      tipo,
      nombre,
      nuevaOpcion: "",
      idFormPrincipal: id,
    };

    try {
      const response = await axios.post(
        "https://portaltransaccionalback.azurewebsites.net/api/CreaPregunta",
        nuevaPregunta
      );

      setPreguntaId(response.data);
      Swal.fire({
        title: "Éxito",
        text: "Pregunta creada con éxito.",
        icon: "success",
        timer: 2000, // La alerta desaparece automáticamente después de 3 segundos
        showConfirmButton: false, // Oculta el botón de confirmación
      });
      setError(false);
      console.log(response.data);
      setNombre(""); // Limpia el campo de nombre
    } catch (error) {
      setMensaje("Error al crear la pregunta");
      setError(true);
      console.error("Error en la solicitud:", error);
    }
  };

  const handleFinalizar = () => {
    Swal.fire({
      title: "¿Está seguro?",
      text: "Se redirigirá al formulario principal.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, finalizar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href = "/Principales";
      }
    });
  };

  const handleTipoChange = (e) => {
    setTipo(e.target.value); // Actualiza el tipo de pregunta
    setPreguntaId(null); // Reinicia el ID de la pregunta
  };
  

  return (
    <div className="container">
      <div className="text-center">
        <div className="container-fluid">
          <div
            className="card shadow mb-4"
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              padding: "20px",
              width: "50%", // Ajusta el ancho del card
              height: "auto", // Ajusta la altura del card
              margin: "0 auto", // Centra el card horizontalmente
            }}
          >
            <div className="card-header py-3">
              <Container maxWidth="sm" style={{ marginTop: "20px" }}>
                <Typography variant="h5" align="center" gutterBottom>
                  Añadir Pregunta
                </Typography>
                <form
                  onSubmit={handleSubmit}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                  }}
                >
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel>Tipo de Pregunta</InputLabel>
                    <Select
                      value={tipo}
                      onChange={handleTipoChange} 
                      label="Tipo de Pregunta"
                    >
                      <MenuItem value="Texto">Texto</MenuItem>
                      <MenuItem value="Correo">Correo</MenuItem>
                      <MenuItem value="Numero">Número</MenuItem>
                      <MenuItem value="Fecha">Fecha</MenuItem>
                      <MenuItem value="Opción Múltiple">
                        Opción Múltiple
                      </MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    label="Nombre de la Pregunta"
                    variant="outlined"
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                    required
                  />
                  
                  <Button type="submit" variant="contained" color="primary">
                    Agregar Pregunta
                  </Button>
                </form>
                {mensaje && (
                  <Alert
                    severity={error ? "error" : "success"}
                    style={{ marginTop: "16px" }}
                  >
                    {mensaje}
                  </Alert>
                )}
                {tipo === "Opción Múltiple" && (
                  <div style={{ marginTop: "16px" }}>
                    {preguntaId ? (
                      <>
                        <Typography variant="h6" gutterBottom>
                          Opciones para la Pregunta
                        </Typography>
                        <CrearOpciones desplegableId={preguntaId} />
                      </>
                    ) : (
                      <Typography variant="body1" color="error">
                        Debe guardar primero la pregunta antes de agregar opciones.
                      </Typography>
                    )}
                  </div>
                )}
                <Button
                  variant="contained"
                  color="inherit"
                  style={{ marginTop: "16px" }}
                  onClick={handleFinalizar}
                >
                  Finalizar
                </Button>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CrearPregunta;
